const URL = "https://crush-backend.vercel.app";

export default URL;
